import { useSocialIndex } from "./useSocialIndex";
import { useTranslation } from "react-i18next";

export function useTikTokIndex() {
  const { t } = useTranslation();

  const indexingMessages = [
    t("account_indexing.tiktok.checking"),
    t("account_indexing.tiktok.analyzing"),
    t("account_indexing.tiktok.gathering_insights"),
    t("account_indexing.tiktok.learning_audience"),
    t("account_indexing.tiktok.organizing"),
    t("account_indexing.tiktok.finalizing")
  ];

  return useSocialIndex({
    triggerEndpoint: '/api/index-tiktok',
    statusEndpoint: '/api/tiktok/social-fetch-status',
    events: {
      startedEvent: 'tiktok-index-triggered',
      completedEvent: 'tiktok-index-completed',
    },
    indexingMessages,
    startToast: 'TikTok data indexing has begun. This may take a few minutes.',
    completeToast: 'TikTok indexing completed. Redirecting to chat...',
    redirectToChatOnSuccess: true,
  });
}